import React, { useEffect, useState } from 'react';

import { BlockStack, Box, Button, Card, Grid, Page, Text } from '@shopify/polaris';

import usePos from '../hooks/Pos';
import { useNavigate } from 'react-router-dom';
import usePosApi from '../hooks/Api';

function PosIndexPage() {
    const { location: getLocation } = usePos();
    const [location, setLocation] = useState(null);
    const [latestOrder, setLatestOrder] = useState(null);
    const [locationConfig, setLocationConfig] = useState(null);
    const { request } = usePosApi();
    const navigate = useNavigate();

    async function refreshPosData() {
        const location = await getLocation();

        // Load latest order eligibility
        const { data: latestOrder } = await request('latest-order');

        setLocation(location);
        setLatestOrder(latestOrder);
    }

    async function getLocationConfig() {
        const { data: locationConfig } = await request('config');

        setLocationConfig(locationConfig);
    }

    useEffect(() => {
        shopify.loading(true);
        refreshPosData()
            .then(getLocationConfig())
            .then(() => {
                shopify.loading(false);
            });
    }, []);

    return (
        <Page narrowWidth title={`Retail Location: ${location ? location.name : 'Loading...'}`}>
            <Card>
                {location && (
                    <>
                        <BlockStack gap="400" paddingBlock="400">
                            <Button size="large" onClick={() => navigate(`/orders`)}>
                                Orders List
                            </Button>
                            <Button
                                size="large"
                                disabled={!latestOrder?.order_id}
                                onClick={() => navigate(`/orders/form?ids=${latestOrder.order_id}&source=list`)}
                            >
                                Manage Tax Form for Latest Order
                            </Button>
                            {!latestOrder?.order_id && <Text tone="critical">No latest order available</Text>}
                            <Button size="large" onClick={() => navigate(`/orders/scan`)}>
                                Scan Receipts
                            </Button>
                            {locationConfig?.printnode_enabled && (
                                <Button size="large" onClick={() => navigate(`/printer`)}>
                                    Configure Printer
                                </Button>
                            )}
                        </BlockStack>
                    </>
                )}
            </Card>
        </Page>
    );
}

export default PosIndexPage;
